// extracted by mini-css-extract-plugin
export var chevron = "_2w-2";
export var chevronCollapsed = "_2w-3";
export var collapsibleHeader = "_2w-1";
export var container = "_2w-0";